/* eslint-disable*/

import React, {useEffect,useRef,useState} from "react";

// library
import styled from 'styled-components';
import PropTypes from "prop-types";
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';
import { useDispatch } from "react-redux";

// component
import Divider from 'components/DividerV2';
import Header from "components/Header";
import { PersonalData,OrganizationData } from './SidebarV3/MenuData';
import Wrapper from './SidebarV3/Wrapper';
import MenuSidebar from './SidebarV3/MenuSidebar';
import Svg from "../../_assets/svg";
import './sidebarV3.scss';
// import Sidebar from "./SidebarV3";

// servicess
import authSvc from "services/authSvc";
import userSvc from "services/userSvc";
import { logout } from "_redux/actions/authAction";
import { Alert } from "utils/Alert";
import ModalTnC from "components/ModalTnC";

const Icon = styled.img``;

const Layout = (props) => {
  const { children } = props;
  const dataUser = authSvc.currentUser();
  const dispatch = useDispatch();
  const [isModalAddTnC, setModalAddTnC] = useState({show: false});

  const location = useLocation();
  const history = useHistory();

  const refLayout = useRef();

  function gotoApiDocumentation() {
    window.open('https://neuapix.gitbook.io/whatsapp-api/getting-started/overview');
  }

  useEffect(()=>{
    // let dataExpired = moment(currentUser?.expiredDate).format('DD-MM-YYYY HH:mm')
    // let CurrentDate = moment().format('DD-MM-YYYY HH:mm');

    // let per = CurrentDate > dataExpired 
    // if(per){
    //   onLogOut()
    // } 

  },[])

  function onLogOut() {
    dispatch(logout());
    localStorage.removeItem("DATA_FORM");
    history.push("/auth/login");
  };

  
  function toggleSidebar(){
    const layout = document.getElementById('main_api');
    const trigger = document.getElementById('button_chevs');
      refLayout?.current?.classList.toggle('sidebar_active');
  } 

  // Integration
  useEffect(() => {
    async function getDataTnCById(id){
      try {
        const params = {
          check: true,
          pp_version: '1.9',
          tnc_version: '1.2.2'
        }
       
        const aggrementTnCData = await userSvc.checkAggrementTnC(id, params);
        // console.log('aggrementTnCData', aggrementTnCData)
        if(!aggrementTnCData?.data?.data?.tnc_accept) {
          setModalAddTnC({show: true})
        }
      } catch (err) {
        Alert.showStatus(
          'error',
          'Error',
          err?.message
        )
      }
    };
    getDataTnCById(dataUser?.user?.id);

  }, [dataUser?.user?.id]);

  return (
    <>
      <Header />
      <div className="d-flex flex-row height-with-header main_api" ref={refLayout}>
        <>
          <div className="wrapper_sidebar" id="wrapper_sidebars">
            <Wrapper className="app_container">
              <div onClick={toggleSidebar} className='button_chev' id="button_chevs">
                <Icon className="image_toggle" src={Svg.chevron_lefth_active.default} alt="chevron" />
              </div>
              <div className='sidebar-container'>
              {
                PersonalData.map(val => {
                  return (
                    <MenuSidebar
                      id={val.id}
                      onClick={() => history.push(val.id)}
                      data={val.data}
                      key={val.id}
                      title={val.title}
                      icon={val.svg}
                      iconActive={val.svg_active}
                      active={location.pathname.indexOf(val.id) >= 0}
                    />
                  )
                })
              }
              {/* <Divider className="margin-inline-20" style={{ marginTop: 20 }} /> */}
                {/* {
                  OrganizationData.map(val => {
                    return (
                      <MenuSidebar
                        id={val.id}
                        onClick={()=>gotoApiDocumentation()}
                        data={val.data}
                        key={val.id}
                        title={val.title}
                        icon={val.svg}
                        iconActive={val.svg_active}
                        active={location.pathname.indexOf(val.id) >= 0}
                      />
                    )
                  })
                } */}
              </div>
            </Wrapper>
          </div>
          <div className={`container_content container-fluid no-pad`}>
            {children}
          </div>
          {/* MODAL TNC */}
          {isModalAddTnC && (
            <ModalTnC isModalAddTnC={isModalAddTnC} setModalAddTnC={setModalAddTnC} />
          )}
        </>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
